import { MemoryStorage } from "@Engage.Core";
class MemoryProxyStorageClass {
    constructor() {
        this.proxyMethods = ["get", "set", "delete", "clear"];
        this.prefixMap = [];
        this.keys = [];
        this.limits = {};
    }
    applyProxy(originalThis, storagePrefix) {
        this.prefixMap.push({ _this: originalThis, prefix: storagePrefix });
        const originalMethods = {};
        for (let method of this.proxyMethods) {
            const isSupported = originalThis.isSupported();
            // cache value to prevent check storage every time
            originalThis.isSupported = () => isSupported;
            // shared methods between all methods
            // bind context
            const originalMethod = originalThis[method].bind(originalThis);
            originalMethods[method] = originalMethod;
            originalThis[method] = (...args) => {
                this.currentContext = originalThis;
                // private method with another signature
                return this["_" + method].apply(this, [originalMethods, ...args]);
            };
        }
        return originalThis;
    }
    isSupported() {
        return true;
    }
    _get(originalMethods, ...args) {
        const method = "get";
        if (this.currentContext.isSupported()) {
            const key = args[0];
            if (!this.limits[this.getExpandKey(key)]) {
                const originalMethod = originalMethods[method];
                return originalMethod.apply(null, args);
            }
        }
        return this[method].apply(this, args);
    }
    get(key) {
        return MemoryStorage.get(this.getExpandKey(key));
    }
    // when storage capacity is empty
    _set(originalMethods, ...args) {
        const method = "set";
        const originalMethod = originalMethods[method];
        if (this.currentContext.isSupported()) {
            // TODO: rewrite
            // options is 2 argument
            const options = args[2];
            let useMemoryFallback = true;
            if (options && typeof options.useMemoryFallback === "boolean") {
                useMemoryFallback = options.useMemoryFallback;
            }
            let result = originalMethod.apply(null, args);
            if (result || !useMemoryFallback)
                return result;
            // context should not change but just for case
            const prevContext = this.currentContext;
            originalMethods["delete"].apply(this, args);
            this.currentContext = prevContext;
            // key is first argument
            const key = args[0];
            this.limits[this.getExpandKey(key)] = true;
        }
        return this[method].apply(this, args);
    }
    set(key, data) {
        const expandKey = this.getExpandKey(key);
        MemoryStorage.set(expandKey, data);
        this.addKey(expandKey);
        return true;
    }
    _delete(originalMethods, ...args) {
        const method = "delete";
        if (this.currentContext.isSupported()) {
            const key = args[0];
            if (!this.limits[this.getExpandKey(key)]) {
                const originalMethod = originalMethods[method];
                return originalMethod.apply(null, args);
            }
        }
        return this[method].apply(this, args);
    }
    delete(key) {
        const expandKey = this.getExpandKey(key);
        this.removeKey(expandKey);
        return MemoryStorage.delete(expandKey);
    }
    _clear(originalMethods, ...args) {
        const method = "clear";
        if (this.currentContext.isSupported()) {
            const originalMethod = originalMethods[method];
            //const limitPrefix = this.getCurrentPrefix();
            //if (Object.keys(this.limits).some(key => key.startsWith(limitPrefix))) {
            //    this[method];
            //}
            originalMethod();
        }
        // always clear or uncomment code above
        return this[method];
    }
    clear() {
        for (let key of this.getCurrentStorageKeys()) {
            this.delete(key);
        }
        return true;
    }
    getExpandKey(key) {
        const storagePrefix = this.getCurrentPrefix();
        return `${storagePrefix}__${key}`;
    }
    getCurrentPrefix() {
        const contextMap = this.prefixMap.find((map) => {
            return map._this === this.currentContext;
        });
        return contextMap ? contextMap.prefix : "NOT_FOUND";
    }
    getCurrentStorageKeys() {
        const currentPrefix = this.getCurrentPrefix();
        return this.keys.filter((key) => key.startsWith(currentPrefix));
    }
    addKey(expandKey) {
        const index = this.keys.indexOf(expandKey);
        if (index === -1) {
            this.keys.push(expandKey);
        }
    }
    removeKey(expandKey) {
        const index = this.keys.indexOf(expandKey);
        if (index !== -1) {
            this.keys.splice(index, 1);
        }
    }
}
export const MemoryProxyStorage = new MemoryProxyStorageClass();
